<template>
  <div
    :class="bem()"
    :style="{ maxWidth, minWidth }"
  >
    <img
      :src="image.src"
      :alt="image.alt"
    />
  </div>
</template>

<script>
export default {
  name: 'SingleImage',

  props: {
    image: {
      type: Object,
      required: true
    },
    mobileImage: {
      type: Object,
      default: () => {}
    },
    maxWidth: {
      type: String,
      default: '100%'
    },
    minWidth: {
      type: String,
      default: null
    }
  },

  setup () {
    return {
      bem: useBEM('SingleImage')
    }
  }
}
</script>

<style lang="postcss">
.SingleImage {
  @apply mb-sm pb-xxs md:mb-md md:pb-0;

  &:last-child {
    @apply mb-0;
  }
}
</style>
